import { ApiService } from '@services/api.service';
import { TableDataApiParams } from '@services/practices.service';
import { Observable, of, throwError } from 'rxjs';
import { TablePaginationRespModel } from '@/models/table-pagination-resp.model';
import { catchError, map, tap } from 'rxjs/operators';
import { TestDriveModel } from '@/models/test-drive/test-drive.model';
import { Injectable } from '@angular/core';
import { LoggerService } from '@services/logger.service';
import { HttpHeaders } from '@angular/common/http';
import { VehicleSearchModel } from '@/models/test-drive/vehicle-search.model';
import { ClienteSearchModel } from '@/models/test-drive/cliente-search.model';

@Injectable({
  providedIn: 'root',
})
export class TestDriveService extends ApiService {
  getDataForTable(
    params?: TableDataApiParams,
  ): Observable<TablePaginationRespModel<TestDriveModel>> {
    return new Observable<TablePaginationRespModel<TestDriveModel>>((observer) => {
      this.http
        .get<TablePaginationRespModel<TestDriveModel>>(this.baseUrl + '/testdrive/page', {
          params: { ...params },
        })
        .pipe(
          tap((response) => {
            observer.next(response);
            observer.complete();
          }),
          catchError((error) => {
            observer.error(error);

            return throwError(error);
          }),
        )
        .subscribe();
    });
  }

  deleteTestDrive(id: number) {
    return this.http.delete(this.baseUrl + `/testdrive/${id}`).pipe(
      map((response: any) => {
        LoggerService.log(response, 'deleteTestDrive');
        return response;
      }),
    );
  }

  saveTestDrive(testDriveModel: TestDriveModel) {
    return this.http.post(this.baseUrl + `/testdrive/save`, testDriveModel).pipe(
      map((response: any) => {
        LoggerService.log(response, 'saveTestDrive');
        return response;
      }),
    );
  }

  getTestDriveById(id: number): Observable<TestDriveModel> {
    return this.http.get(this.baseUrl + `/testdrive/${id}`).pipe(
      map((response: any) => {
        LoggerService.log(response, 'getTestDriveById');

        return response;
      }),
    );
  }

  downloadPdf(id: number) {
    return this.http.get(this.baseUrl + `/testdrive/${id}/pdf`, {
      headers: new HttpHeaders({ 'Content-Type': 'application/octet-stream' }),
      responseType: 'blob',
    });
  }

  searchVehicle(searchQuery: string): Observable<VehicleSearchModel[]> {
    if (!searchQuery || searchQuery.length < 4) {
      return new Observable((observer) => {
        observer.next([]);
        observer.complete();
      });
    }

    return this.http
      .get<VehicleSearchModel[]>(this.baseUrl + `/testdrive/vehicles`, {
        params: { filter: searchQuery },
      })
      .pipe(
        map((response: any) => {
          LoggerService.log(response, 'searchVehicle');
          return response;
        }),
        catchError((error) => {
          LoggerService.error('searchVehicle failed', error);
          return of([]);
        }),
      );
  }

  searchCliente(searchQuery: string): Observable<ClienteSearchModel[]> {
    if (!searchQuery || searchQuery.length < 3) {
      return new Observable((observer) => {
        observer.next([]);
        observer.complete();
      });
    }

    return this.http
      .get<ClienteSearchModel[]>(this.baseUrl + `/testdrive/customers`, {
        params: { filter: searchQuery },
      })
      .pipe(
        map((response: any) => {
          LoggerService.log(response, 'searchCustomers');
          return response;
        }),
        catchError((error) => {
          LoggerService.error('searchCustomers failed', error);
          return of([]);
        }),
      );
  }
}
